export const trackingEvents = {
  SAVE_BUTTON: {
    CLICKED: 'matching_explainability.search.clicked',
  },
}
